<script setup>
import footerQuery from '~/assets/gql/footer.gql'
import { useAppStore } from '~/store/main'

const { locale } = useI18n()
const store = useAppStore()
const { internalLinksListener } = useInternalLinkHandler()

const { getIsDesktop } = storeToRefs(store)
const footer1 = ref(null)

const { result: queryData } = useQuery(
  footerQuery,
  {
    language: locale.value.toUpperCase(),
  },
  {
    enabled: !!import.meta.client,
  }
)

const data = computed(() => queryData.value?.articles?.nodes[0])

onMounted(() => {
  setTimeout(() => {
    if (footer1.value) {
      const links = footer1.value.getElementsByTagName('A')
      Array.from(links).forEach((element) => {
        internalLinksListener(element)
      })
    }
  }, 100)
})
</script>

<template>
  <footer class="footer">
    <div v-show="!getIsDesktop" class="bread">
      <ClientOnly>
        <BreadCrumber />
      </ClientOnly>
    </div>
    <div class="desktopWrapper">
      <NavigationBottom />
      <ClientOnly>
        <div
          v-if="data && data.id"
          ref="footer1"
          class="text_minor_2 is_c2 footer__inner"
          v-html="data.GlobalAttributes.footer"
        />
      </ClientOnly>
    </div>
    <div v-show="!getIsDesktop" class="switcher">
      <LanguageSwitcher />
      <ThemeSwitcher />
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid $color-root;
  margin: 160px -20px 0 -20px;
  padding: 30px 20px 36px 20px;
  background-color: $color-1;
  transition: background-color 0.3s;

  @include media-breakpoint-up(sm) {
    padding: 30px 40px 36px 40px;
    margin: 130px 0 0 0;
    width: 100vw;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  &__inner {
    margin-top: 78px;
    @include media-breakpoint-up(sm) {
      margin-top: 0px;

      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;

      gap: 70px;
    }
  }
}

.footer:deep(p) {
  padding: 10px 0;
  // white-space: nowrap;
  a {
    color: $color-root;
    &:hover {
      color: $color-2;
    }
  }
}

.desktopWrapper {
  @include media-breakpoint-up(sm) {
    display: flex;
    flex-flow: row-reverse nowrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 70px;
    max-width: 1800px;
    margin: 0 auto;
  }
}

.switcher {
  margin-top: 30px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}

.bread {
  margin: 0 -3px 64px;
}
</style>
